// extracted by mini-css-extract-plugin
module.exports = {"area":"style_area__obK33","dec":"style_dec__2NC97"};